// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/bugreport/v1/bugreport.proto (package mono.bugreport.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.bugreport.v1.CreateBugReportRequest
 */ export class CreateBugReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateBugReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBugReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBugReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBugReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * Context captured from the page the reporter was on. It goes into the
   * issue description rather than separate fields, because Jira has nowhere
   * structured to put it and a reader wants it inline anyway.
   *
   * @generated from field: string page_url = 3;
   */ _define_property(this, "pageUrl", ""), /**
   * @generated from field: string browser_info = 4;
   */ _define_property(this, "browserInfo", ""), /**
   * @generated from field: string timestamp = 5;
   */ _define_property(this, "timestamp", ""), /**
   * Optional attachments. Bytes rather than an upload URL: a screenshot is
   * small, it is captured in the browser and never exists as a stored object,
   * and a separate upload round-trip would be a second thing to fail.
   *
   * @generated from field: bytes screenshot = 6;
   */ _define_property(this, "screenshot", new Uint8Array(0)), /**
   * @generated from field: string screenshot_filename = 7;
   */ _define_property(this, "screenshotFilename", ""), /**
   * Serialized client state, attached as a file for the same reason.
   *
   * @generated from field: string app_state = 8;
   */ _define_property(this, "appState", ""), /**
   * The reporter's recording and its transcript, when the report was spoken.
   * The audio is attached as-is; the transcript goes inline beside the
   * description, since the description is a model's rewrite of it and a
   * reader should be able to check one against the other.
   *
   * @generated from field: bytes audio = 9;
   */ _define_property(this, "audio", new Uint8Array(0)), /**
   * @generated from field: string audio_filename = 10;
   */ _define_property(this, "audioFilename", ""), /**
   * @generated from field: string transcript = 11;
   */ _define_property(this, "transcript", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateBugReportRequest, "runtime", proto3);
_define_property(CreateBugReportRequest, "typeName", "mono.bugreport.v1.CreateBugReportRequest");
_define_property(CreateBugReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "browser_info",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "timestamp",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "screenshot",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 7,
            name: "screenshot_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "app_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "audio",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 10,
            name: "audio_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "transcript",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.DraftBugReportRequest
 */ export class DraftBugReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new DraftBugReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftBugReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftBugReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftBugReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * A browser MediaRecorder capture. The filename carries the container
   * (e.g. "report.webm"), which is how the transcriber tells formats apart.
   *
   * @generated from field: bytes audio = 1;
   */ _define_property(this, "audio", new Uint8Array(0)), /**
   * @generated from field: string audio_filename = 2;
   */ _define_property(this, "audioFilename", ""), /**
   * Where the reporter was, so the draft can name the screen they mean.
   *
   * @generated from field: string page_url = 3;
   */ _define_property(this, "pageUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftBugReportRequest, "runtime", proto3);
_define_property(DraftBugReportRequest, "typeName", "mono.bugreport.v1.DraftBugReportRequest");
_define_property(DraftBugReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audio",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "audio_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.DraftBugReportResponse
 */ export class DraftBugReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new DraftBugReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftBugReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftBugReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftBugReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string transcript = 1;
   */ _define_property(this, "transcript", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftBugReportResponse, "runtime", proto3);
_define_property(DraftBugReportResponse, "typeName", "mono.bugreport.v1.DraftBugReportResponse");
_define_property(DraftBugReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "transcript",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.CreateBugReportResponse
 */ export class CreateBugReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateBugReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBugReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBugReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBugReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string jira_ticket_number = 1;
   */ _define_property(this, "jiraTicketNumber", ""), /**
   * @generated from field: string jira_url = 2;
   */ _define_property(this, "jiraUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateBugReportResponse, "runtime", proto3);
_define_property(CreateBugReportResponse, "typeName", "mono.bugreport.v1.CreateBugReportResponse");
_define_property(CreateBugReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jira_ticket_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "jira_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.ListBugReportsRequest
 */ export class ListBugReportsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBugReportsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBugReportsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBugReportsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBugReportsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 2;
   */ _define_property(this, "pageSize", 0), /**
   * Filters by Jira status category; empty means all.
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBugReportsRequest, "runtime", proto3);
_define_property(ListBugReportsRequest, "typeName", "mono.bugreport.v1.ListBugReportsRequest");
_define_property(ListBugReportsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.BugReport
 */ export class BugReport extends Message {
    static fromBinary(bytes, options) {
        return new BugReport().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BugReport().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BugReport().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BugReport, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string jira_ticket_number = 1;
   */ _define_property(this, "jiraTicketNumber", ""), /**
   * @generated from field: string jira_url = 2;
   */ _define_property(this, "jiraUrl", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string reporter = 6;
   */ _define_property(this, "reporter", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * Empty while the issue is unassigned, which is the common case for a
   * freshly filed report.
   *
   * @generated from field: string assignee = 8;
   */ _define_property(this, "assignee", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BugReport, "runtime", proto3);
_define_property(BugReport, "typeName", "mono.bugreport.v1.BugReport");
_define_property(BugReport, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jira_ticket_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "jira_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reporter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "assignee",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.bugreport.v1.ListBugReportsResponse
 */ export class ListBugReportsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBugReportsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBugReportsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBugReportsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBugReportsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.bugreport.v1.BugReport reports = 1;
   */ _define_property(this, "reports", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 page = 3;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 4;
   */ _define_property(this, "pageSize", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBugReportsResponse, "runtime", proto3);
_define_property(ListBugReportsResponse, "typeName", "mono.bugreport.v1.ListBugReportsResponse");
_define_property(ListBugReportsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reports",
            kind: "message",
            T: BugReport,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
